import { Link } from "react-router-dom";
import AdminSideNav from "../../layouts/adminSideNav";
import Navbar from "../../layouts/nav";
import { useEffect } from "react";

export default function AdminCategory(props){
    useEffect(() => {
		// List of JS files to reload
		const jsFiles = [
		  'assets/js/scrolltoTop.js',
      'assets/js/custom.js'
		];
	
		// Create script elements for each JS file
		jsFiles.forEach((filePath) => {
		  const script = document.createElement('script');
		  script.src = filePath;
		  script.async = true;
		  document.body.appendChild(script);
		});
	
		// Clean up the script elements when the component unmounts
		return () => {
		  jsFiles.forEach((filePath) => {
			const script = document.querySelector(`[src="${filePath}"]`);
			if (script) {
			  document.body.removeChild(script);
			}
		  });
		};
	  }, []);
    return(
        <>
        <Navbar style={'#1A374D'}></Navbar>
 <body className="g-sidenav-show dark-version bg-gray-100" style={{marginTop: '5rem'}}>
    <AdminSideNav active={props.heading}/>
  <main className="main-content position-relative border-radius-lg " style={{overflowY: 'scroll'}}>

  <div className="container-fluid py-4">
             <div className="row">
        <div className="col-12">
        <h1 className="text-center display-4">Category - {props.heading}</h1>
        <hr style={{border: 'solid 2px white'}}/>
        <h1 className="text-center" style={{marginTop: '2rem'}}>Animal Data</h1>
          <div className="card mb-4 dark-version"  style={{marginTop: '4rem', borderRadius: '20px', border: 'solid 2px white'}}>
            <div className="card-header pb-0">
              <h6>Admin Table</h6>
            </div>
            <div className="card-body px-0 pt-0 pb-2">
              <div className="table-responsive p-0">
                <table className="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th className="text-uppercase text-secondary text-md font-weight-bolder opacity-7"><input type="checkbox"></input><span style={{marginLeft: '1rem'}}>Name</span></th>
                      <th className="text-uppercase text-secondary text-md font-weight-bolder opacity-7 ps-2">Class</th>
                      <th className="text-center text-uppercase text-secondary text-md font-weight-bolder opacity-7">Order</th>
                      <th className="text-center text-uppercase text-secondary text-md font-weight-bolder opacity-7">Location</th>
                      <th className="text-secondary opacity-7"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                    <tr>
                      <td>
                        <div className="d-flex px-2 py-1">

                          <div className="d-flex flex-column justify-content-center">
                          
                            <h6 style={{display: 'inline-block'}} className="mb-0 text-md"><input type='checkbox'></input><span style={{marginLeft: '1rem'}}>Cheetah</span></h6>
                  
                          </div>
                        </div>
                      </td>
                      <td>
                        <p className="text-sm font-weight-bold mb-0">Mammalia</p>
                 
                      </td>
                      <td className="align-middle text-center text-sm">
                        <span className="text-sm font-weight-bold mb-0">Carnivora</span>
                      </td>
                      <td className="align-middle text-center">
                        <span className="text-sm font-weight-bold mb-0">Africa, Asia, Eurasia</span>
                      </td>
                      <td className="align-middle">
                        <a href="javascript:;" className="text-secondary font-weight-bold text-xs" data-toggle="tooltip" data-original-title="Edit user">
                          Edit
                        </a>
                      </td>
                    </tr>
                    
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
             </div>
           
      </div>
      </main>
      </body>
        </>
    );
}